(function () {
  function initBlogGrid(root) {
    const section = root.matches('[data-blog-grid]') ? root : root.querySelector('[data-blog-grid]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const grid = section.querySelector('[data-blog-grid-items]');
    const loadMoreBtn = section.querySelector('[data-load-more]');
    if (!grid || !loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', async () => {
      const nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl || loadMoreBtn.disabled) return;

      loadMoreBtn.disabled = true;

      try {
        const response = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Failed to load articles');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedSection = doc.querySelector('[data-blog-grid]');
        const fetchedGrid = fetchedSection?.querySelector('[data-blog-grid-items]');
        const fetchedLoadMore = fetchedSection?.querySelector('[data-load-more]');

        if (fetchedGrid) {
          fetchedGrid.querySelectorAll('[data-blog-article-card]').forEach((card) => {
            grid.appendChild(card);
          });
        }

        if (fetchedLoadMore?.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = fetchedLoadMore.dataset.nextUrl;
          loadMoreBtn.disabled = false;
        } else {
          loadMoreBtn.hidden = true;
        }
      } catch {
        loadMoreBtn.disabled = false;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-blog-grid]').forEach(initBlogGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-blog-grid]');
    if (section) {
      section.dataset.initialized = 'false';
      initBlogGrid(section);
    }
  });
})();
